module.exports = __webpack_public_path__ + "img/safe-harbor-bad-bot.31741772.svg";